define.alias("shared/utils/formatters/caption-from-regram", "settings/utils/formatters/caption-from-regram");